import { h, JSX } from 'preact';

import { Modal } from './Modal';

export interface MessageModalProps {
    title: string;
    text: string;
    confirmLabel: string;
    onConfirm: () => void;
    // A second, plain button that only closes the dialog.
    cancelLabel?: string;
    onCancel?: () => void;
}

/**
 * A message the cashier has to act on before going on, with one button, or two when they may also back out.
 */
export const MessageModal = (props: MessageModalProps): JSX.Element => (
    <Modal show={true} toggleModal={props.onCancel ?? props.onConfirm} title={props.title}>
        <div class="flex flex-col items-center gap-8 px-10 pt-8 pb-10 text-center">
            <p class="text-base">{props.text}</p>
            <div class="flex w-full items-center justify-center gap-6">
                {props.cancelLabel && (
                    <button
                        type="button"
                        className="btn btn-border grow min-w-[160px] px-4 py-6 text-base font-semibold"
                        onClick={props.onCancel}
                    >
                        {props.cancelLabel}
                    </button>
                )}
                <button
                    type="button"
                    className="btn btn-light-blue grow min-w-[160px] px-4 py-6 text-base font-semibold"
                    onClick={props.onConfirm}
                >
                    {props.confirmLabel}
                </button>
            </div>
        </div>
    </Modal>
);
